import styled from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

const _MenuMargauxMotinRoot = styled.div`
  position: relative;
  padding: 0px 0;

  @media ${responsiveMap.mobile} {
    padding: 32px 0;
  }

  .landing-menu__container {
    position: relative;
    z-index: 1;
  }

  .menu-margaux-motin-content-wrapper {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    max-width: 486px;
    width: 100%;
  }

  .menu-margaux-motin-background-wrapper {
    position: absolute;
    top: 50%;
    z-index: 0;
    transform: translateY(-50%);
    .menu-margaux-motin-background-wrapper-content {
      position: relative;
    }
  }

  .menu-margaux-motin-background {
    @media ${responsiveMap.mobile} {
      scale: 0.8;
    }
  }
`;

export { _MenuMargauxMotinRoot };
